import React from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap';

import { HistoriesPanel } from '@admin/components/histories/panel';
import { Spinner } from '@admin/components/spinner';
import { useNavigate } from '@admin/hooks/use_navigate';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { History__Subject, Coupon__Input, useCouponQuery, useCouponUpdateMutation } from '@admin/schema';

import { CouponForm } from './form';

export const Edit: React.FC = () => {
  useTitle('Edit Coupon');
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useCouponQuery({ client, variables: { id } });
  const [execute, { loading: saving }] = useCouponUpdateMutation({ client });
  const navigate = useNavigate();
  const onSave = () => {
    navigate('/marketing/coupons');
  };

  return (
    <>
      <div className="page-header">
        <Breadcrumb>
          <Breadcrumb.Item>
            <NavLink to="/marketing/coupons">Coupons</NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Edit</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      {loading && <Spinner />}
      {data && (
        <CouponForm
          coupon={data.coupon}
          save={(input: Coupon__Input) => execute({ variables: { input, id: data.coupon.id } })}
          onSave={onSave}
          loading={saving}
        />
      )}
      <HistoriesPanel id={id} type={History__Subject.Coupon}></HistoriesPanel>
    </>
  );
};
